export const POPUP_STORAGE_KEY = 'AuroraTheme-Popup'

export const POPUP_CLASSNAMES = {
  lightboxActive: 'popup--active',
  lightboxClosing: 'popup--closing',
  success: 'popup--success',
  showImage: 'popup--show-image',
}
